(function () {
  var HIDE_SELECTORS = [
    'shop-visual-search',
    'visual-search-component',
    'shopify-visual-search',
    '[data-shopify-visual-search]',
    '[data-visual-search]',
    '[class*="visual-search"]',
    '[class*="VisualSearch"]',
    'shopify-editor-visual-search',
    '[data-shopify-editor-visual-search]'
  ];

  var HIDE_LABELS = [
    'recherche visuelle',
    'visual search',
    'search by image',
    'paramètre',
    'parametre',
    'settings',
    'shopify visual'
  ];

  var IMAGE_HOLDERS = [
    '.product-card__image-holder',
    '.product-card__image',
    '.bnexo-single-card__frame',
    '.thumbnail__image__container',
    '.global-media-settings'
  ];

  function shouldHide(el) {
    if (!el || el.nodeType !== 1) return false;
    var label = (el.getAttribute('aria-label') || el.getAttribute('title') || el.textContent || '').toLowerCase();
    if (HIDE_LABELS.some(function (term) { return label.indexOf(term) !== -1; })) return true;
    if (el.tagName === 'MODAL-OPENER' && el.closest('.product-card__image-holder')) return true;
    if (el.classList && (el.classList.contains('btn-quickview') || el.classList.contains('product__media-icon'))) return true;
    return false;
  }

  function isCenteredOverlay(el, holder) {
    if (!holder || !el.getBoundingClientRect) return false;
    var er = el.getBoundingClientRect();
    var hr = holder.getBoundingClientRect();
    if (er.width < 8 || er.height < 8) return false;
    if (er.width > hr.width * 0.85 && er.height < hr.height * 0.25) return false;
    var ecx = er.left + er.width / 2;
    var ecy = er.top + er.height / 2;
    var hcx = hr.left + hr.width / 2;
    var hcy = hr.top + hr.height / 2;
    return Math.abs(ecx - hcx) < hr.width * 0.28 && Math.abs(ecy - hcy) < hr.height * 0.28;
  }

  function hideNode(el) {
    if (!el || el.nodeType !== 1) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.style.setProperty('opacity', '0', 'important');
  }

  function sweepHolder(holder) {
    if (!holder) return;
    if (holder.closest('.bnexo-product-page, .main-product, .product-page-section')) return;
    holder.querySelectorAll('button, [role="button"], modal-opener, shop-visual-search, visual-search-component, iframe, [class*="visual-search"]').forEach(function (el) {
      if (el.closest('.badge__container')) return;
      if (shouldHide(el) || isCenteredOverlay(el, holder)) hideNode(el);
    });
  }

  function sweep(root) {
    var scope = root || document;
    HIDE_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(hideNode);
    });
    scope.querySelectorAll('button, a, [role="button"], modal-opener').forEach(function (el) {
      if (shouldHide(el)) hideNode(el);
    });
    IMAGE_HOLDERS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(sweepHolder);
    });
  }

  function init() {
    sweep(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (shouldHide(node)) hideNode(node);
          sweep(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('scroll', function () { sweep(document); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
